/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * Factory which builds a filter that truncates a string variable if its length is too long. '...' characters are
 * automatically appended at the end of the truncated string.
 *
 * @ngInject
 */
function TruncateFilterFactory($log) {
    const filter = function(text, maxLength) {
        return (angular.isString(text) && (text.length > maxLength)) ? text.substr(0, maxLength) + '...' : text;
    };

    $log.debug('Factory \'TruncateFilter\' loaded');
    return filter;
}

export { TruncateFilterFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/filter/TruncateFilter.js